"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviousQuestionAction = void 0;
const adaptivecards_1 = require("adaptivecards");
const __1 = require("../..");
function PreviousQuestionAction(surveyId, questionOrdinal) {
    return __1.CardHelper.create(adaptivecards_1.SubmitAction, {
        // NOTE: if this text is changed, make sure to change the text in Polly preview as well.
        title: "❮ Previous",
        isPrimary: false,
        data: (0, __1.SurveyResultsViewCommand)(surveyId, {
            questionOrdinal,
        }).toTaskFetchCommand(),
    });
}
exports.PreviousQuestionAction = PreviousQuestionAction;
//# sourceMappingURL=PreviousQuestionAction.js.map